import { connect } from 'react-redux';
import Const from '../../../config/const';
import SelectChatCredit from './select_chat_credit';
import {
  selectCredit,
  cancelChat,
  loadPricingOptions,
  trackDurationPickExit,
  selectDurationOption
} from '../../../actions/chat';
import {
  cancelVoipChat,
  loadVoipPricingOptions,
  selectVoipCredit,
  trackVoipDurationPickExit,
  selectVoipDurationOption
} from '../../../actions/voip_chat';
import withPGTranslation from '../../../config/withPGTranslation';
import { displayAffiliatePromoPopupAction, clearAffiliatePromoPopup } from '../../../actions/affiliate_promo_popup';
import { getUserFirstActivePromotion, getUserMatchUpBonusInfo, getAdvisorXfmProgram } from '../../../config/util';

const getAdvisorMode = ({ advisors, advisorId, chatType }) => {
  const advisor = (advisors || {})[parseInt(advisorId, 10)];
  const liveModes = advisor && advisor.liveModes;
  const advisorMode = liveModes.find(mode => mode.mode === Const.chatTypeToModeName[chatType]);
  return advisorMode;
};

const getAdvisorModeLocalPromoPrices = ({ advisors, advisorId, chatType }) => {
  const advisorMode = getAdvisorMode({ advisors, advisorId, chatType });
  return advisorMode.localPromoPrices;
};

const getAdvisorModePricePerMinute = ({ advisors, advisorId, chatType }) => {
  const advisorMode = getAdvisorMode({ advisors, advisorId, chatType });
  return advisorMode.price;
};

const mapStateToProps = ({
  chat, voipChat, user: { user }, advisors, application, affiliatePromoPopup: { showAffiliatePromoPopup }
}, { isContinue, chatType }) => {
  switch (chatType) {
    case Const.chatType.text:
      return ({
        ...chat,
        isContinue,
        localAvailableCredit: user && user.localAvailableCredit,
        currency: user && user.currency,
        disabledStartChatButton:
          chat.state !== Const.chatStates.appInitial
          && chat.state !== Const.chatStates.paused,
        userShowMatchUpBonusInfo: user && user.showMatchUpBonusInfo,
        isNewUser: chat && chat.selectDurationKind === Const.selectDurationKind.newUser,
        advisorXfmProgram: getAdvisorXfmProgram({ advisors, advisorId: chat.advisorId }),
        userXfmProgram: user && user.xfmProgram,
        loading: chat.loading || (user && user.paymentProcessing),
        selectDurationKind: chat && chat.selectDurationKind,
        userAdvisorModeSalePrice: getUserFirstActivePromotion({ user, application })?.advisorModeSalePrice,
        localPromoPrices: getAdvisorModeLocalPromoPrices({ advisors, advisorId: chat.advisorId, chatType }),
        advisorModePricePerMinute: getAdvisorModePricePerMinute({ advisors, advisorId: chat.advisorId, chatType }),
        matchUpBonusInfo: getUserMatchUpBonusInfo({ bonusInfos: user && user.bonusInfos }) ?? application?.dynamicConfig?.matchUpBonusInfo,
        trackDurationPickExit,
        showAffiliatePromoPopup
      });
    case Const.chatType.voice:
    case Const.chatType.video:
      return ({
        ...voipChat,
        isContinue,
        localAvailableCredit: user && user.localAvailableCredit,
        currency: user && user.currency,
        disabledStartChatButton:
          voipChat.voipState !== Const.voipChatStates.initial
          && voipChat.voipState !== Const.voipChatStates.paused,
        userShowMatchUpBonusInfo: user && user.showMatchUpBonusInfo,
        isNewUser: voipChat && voipChat.selectDurationKind === Const.selectDurationKind.newUser,
        advisorXfmProgram: getAdvisorXfmProgram({ advisors, advisorId: voipChat.advisorId }),
        userXfmProgram: user && user.xfmProgram,
        loading: voipChat.loading || (user && user.paymentProcessing),
        selectDurationKind: voipChat && voipChat.selectDurationKind,
        userAdvisorModeSalePrice: getUserFirstActivePromotion({ user, application })?.advisorModeSalePrice,
        localPromoPrices: getAdvisorModeLocalPromoPrices({ advisors, advisorId: voipChat.advisorId, chatType }),
        advisorModePricePerMinute: getAdvisorModePricePerMinute({ advisors, advisorId: voipChat.advisorId, chatType }),
        matchUpBonusInfo: getUserMatchUpBonusInfo({ bonusInfos: user && user.bonusInfos }) ?? application?.dynamicConfig?.matchUpBonusInfo,
        trackDurationPickExit: trackVoipDurationPickExit,
        showAffiliatePromoPopup
      });
    default:
      return null;
  }
};

const defaultFunctions = (dispatch) => ({
  displayAffiliatePromoPopupAction: (creditMatchingInfo, type, additionParams) => {
    dispatch(displayAffiliatePromoPopupAction(creditMatchingInfo, type, additionParams));
  },
  clearAffiliatePromoPopup: () => dispatch(clearAffiliatePromoPopup())
});

const defaultVoipFunctions = (dispatch) => ({
  selectCredit: (option, time, defaultDurationChanged, isContinue) => dispatch(
    selectVoipCredit(option, time, defaultDurationChanged, isContinue)
  ),
  cancelChat: () => dispatch(cancelVoipChat()),
  selectDurationOption: (option, onContinue, isNewUser, index) => dispatch(
    selectVoipDurationOption(option, onContinue, isNewUser, index)
  )
});

const mapDispatchToProps = (dispatch, ownProps) => {
  switch (ownProps.chatType) {
    case Const.chatType.text:
      return ({
        selectCredit: (option, time, defaultDurationChanged, isContinue) => dispatch(
          selectCredit(option, time, defaultDurationChanged, isContinue)
        ),
        cancelChat: () => dispatch(cancelChat()),
        loadPricingOptions: (advisorId) => dispatch(loadPricingOptions('chat', advisorId)),
        selectDurationOption: (option, isContinue, isNewUser, index) => dispatch(
          selectDurationOption(option, isContinue, isNewUser, index)
        ),
        ...defaultFunctions(dispatch)
      });
    case Const.chatType.video:
      return ({
        loadPricingOptions: (advisorId) => dispatch(loadVoipPricingOptions('video', advisorId)),
        ...defaultVoipFunctions(dispatch),
        ...defaultFunctions(dispatch)
      });
    case Const.chatType.voice:
      return ({
        loadPricingOptions: (advisorId) => dispatch(loadVoipPricingOptions('voice', advisorId)),
        ...defaultVoipFunctions(dispatch),
        ...defaultFunctions(dispatch)
      });
    default:
      return null;
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withPGTranslation(SelectChatCredit));
